import { nb } from '@/i18n/nb';
import s from './Eierseksjon.module.css';

/*
 * Eierseksjon placeholder (Iter 10), rendered inside the landing slide-overlay.
 * The card itself is owner-gated in CardGrid (ownerOnly), so this body is only
 * ever reached by owner/admin. It shows a prominent "Kommer snart" plus the list
 * of intended subsections — stubs only, no real Eierseksjon features yet.
 */
export function Eierseksjon() {
  return (
    <div className={s.eier}>
      <p className={s.comingSoon}>{nb.modules.comingSoon}</p>
      <p className={s.lead}>{nb.eier.lead}</p>
      <p className={s.subsectionsLabel}>{nb.eier.subsectionsLabel}</p>
      <ul className={s.subsections}>
        {nb.eier.subsections.map((subsection) => (
          <li key={subsection}>{subsection}</li>
        ))}
      </ul>
    </div>
  );
}
